class AutoApplyJobView {
  constructor($el) {
    if (!$el.length) return

    this.$root = $el
    this.initAssignment()
    this.initUnavailablePostingModal()
  }

  initAssignment() {
    this.$root.on('click', '#auto-apply-assign-me', evt => {
      evt.preventDefault()
      this.assignMe(evt.currentTarget)
    })
  }

  initUnavailablePostingModal() {
    this.$root.on('click', '.unavailable-posting-modal', evt => {
      const $target = $(evt.target)

      if ($target.is('.modal-overlay, .modal-close, .modal-close-btn')) {
        window.location.reload()
      }
    })
  }

  assignMe(element) {
    const jobId = element.dataset.id
    const employeeName = element.dataset.name
    const url = `${window.location.origin}/admin/auto_apply_jobs/job_card/${jobId}/assign_me`

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(response => {
        if (response.status === 410) {
          this.$root.find('.unavailable-posting-modal').css('display', 'flex')
          return
        }

        if (response.status !== 204) {
          const flashMessage = response.headers.get('X-Flash-Notice')

          console.log('Looks like there was a problem. Status Code: ' + response.status)

          if (flashMessage) {
            alert(flashMessage)
          }
          return
        }

        if (element.dataset.reload) {
          window.location.reload()
          return
        }

        $(element)
          .closest('div.jobs__table-text')
          .html(`<div class="jobs__table-user-text">${employeeName}</div>`)
      })
      .catch(console.error)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new AutoApplyJobView($('.jobs-view'))
})
